import { render, staticRenderFns } from "./coursePacketsItems.vue?vue&type=template&id=2215136b&scoped=true&"
import script from "./coursePacketsItems.vue?vue&type=script&lang=js&"
export * from "./coursePacketsItems.vue?vue&type=script&lang=js&"
import style0 from "./coursePacketsItems.vue?vue&type=style&index=0&id=2215136b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215136b",
  null
  
)

export default component.exports